export default __webpack_public_path__ + "static/media/chevron-up.8e1e2a73.svg";